import { GRADUATION_LOOKBACK_DAYS } from "../../../constants/graduation";

export type StatsFiltersState = {
    startDate: Date | undefined;
    endDate: Date | undefined;
    timeslotFilter: string | undefined;
    challengeFilter: string | undefined;
    selectedTags: string[];
    selectedRoles: string[];
    favoritesOnly: boolean;
    hasFiltersBeenModified: boolean;
};

export const INITIAL_STATS_FILTERS_STATE: StatsFiltersState = {
    startDate: undefined,
    endDate: undefined,
    timeslotFilter: undefined,
    challengeFilter: undefined,
    selectedTags: [],
    selectedRoles: [],
    favoritesOnly: false,
    hasFiltersBeenModified: false,
};

/** Période par défaut des stats admin : les 90 derniers jours. */
export const getDefaultStatsDateRange = (referenceDate: Date = new Date()) => {
    const endDate = new Date(
        referenceDate.getFullYear(),
        referenceDate.getMonth(),
        referenceDate.getDate()
    );
    const startDate = new Date(endDate);
    startDate.setDate(startDate.getDate() - GRADUATION_LOOKBACK_DAYS);
    return { startDate, endDate };
};
